var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3144 0.512185L4.38414 8.87946L1.4703 5.80502C1.32902 5.65596 1.09996 5.65596 0.958656 5.80502L0.105955 6.70471C-0.0353182 6.85377 -0.0353182 7.09546 0.105955 7.24455L4.12831 11.4886C4.26958 11.6377 4.49865 11.6377 4.63995 11.4886L13.6787 1.95172C13.8199 1.80266 13.8199 1.56097 13.6787 1.41188L12.826 0.512185C12.6847 0.363126 12.4556 0.363126 12.3144 0.512185Z",
    fill: "#CCD6DD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayCheck);
export default __webpack_public_path__ + "static/media/GrayCheck.949fd6fd.svg";
export { ForwardRef as ReactComponent };